import React, { useState, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import SFSplideContainer from "../splide/splideContainer";

const SFCarouselContainer = ({
  children,
  autoWidth = false,
  perPage = null,
}) => {
  const [showArrows, setShowArrows] = useState(true);
  const params = {
    padding: 80,
    gap: 24,
    fixedWidth: 323,
  };

  const size = useWindowSize();
  useEffect(() => {
    perPage
      ? setShowArrows(children.length > perPage)
      : setShowArrows(
        children.length * (params.fixedWidth + params.gap) + params.padding >
        size.width
      );
  }, [size, children.length]);

  const options = {
    //type: "loop",
    //rewind: true,
    //width: "100%",
    gap: params.gap,
    perMove: 1,
    //autoWidth: true,
    pauseOnHover: true,
    pagination: false,
    padding: { left: params.padding, right: params.padding },
    arrows: showArrows,
    perPage: autoWidth ? 1 : perPage,
    lazyLoad: "nearby",
    preloadPages: 6,
    autoWidth,
    fixedWidth: false,
  };
  return <SFSplideContainer children={children} options={options} />;
};

export default SFCarouselContainer;
